import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "redirect" */ './index'),
  loading: () => null,
})
